import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';

import NavStrip from './components/NavStrip';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ResidentialSolar from './pages/ResidentialSolar';
import CommercialSolar from './pages/CommercialSolar';
import AboutInformation from './pages/AboutInformation';
import NavbarBackgroundImage from './images/Nav.png';


function App() {
  const navbarBackgroundStyle = {
    backgroundImage: `url(${NavbarBackgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
  };

  return (
    <Router>
     <Navbar/>
      <div className="App">
        <main >
          <Routes>
            <Route path="/" element={<Home />} />
             <Route path="/about-info" element={<AboutInformation />} />
            <Route path="/residential-solar" element={<ResidentialSolar />} />
            <Route path="/commercial-solar" element={<CommercialSolar />} />
            <Route path="/login" element={<div>Login Page Content Here</div>} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
